import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatRadioField } from '@blocks-react/components/RadioField';
import { BlocksRadioChangeEvent } from '@blocks-web-components/events';
import styles from '../NotificationFilterDrawer.module.scss';

interface AccountStatus {
  label: string;
  value: string;
  name: string;
  default: boolean;
}

interface SelectedAccount {
  label: string;
  value: string;
}

interface AccountRadioButtonsProps {
  selectedAccount?: SelectedAccount;
  handleRadioButton: (e: BlocksRadioChangeEvent, value: string) => void;
  accountList: AccountStatus[];
}

export const AccountRadioButtons: FC<AccountRadioButtonsProps> = ({
  selectedAccount = {},
  handleRadioButton,
  accountList = []
}) => {
  return (
    <div className={`${styles['account_radio_wrapper']}`}>
      {accountList?.map((account: AccountStatus) => (
        <div
          className={`d-flex align-items-center ${styles['account_radio_margin']}`}
          key={account.value}
        >
          <CatRadioField
            checked={selectedAccount.label === account.label}
            onBlRadioChange={(e: BlocksRadioChangeEvent) =>
              handleRadioButton(e, account.value)
            }
            name="selectedAccount"
            value={account.label}
            data-testid={account.label}
          >
            <CatHeading
              variant="body-sm"
              aria-label={`${account.value}${account.name}`}
            >
              {account.value}
              {` - `}
              {account.name}
            </CatHeading>
          </CatRadioField>
        </div>
      ))}
    </div>
  );
};
